module.exports = __webpack_public_path__ + "a18fae09111ce6d6ac483acd052ded1c.png";